// File: src/utils/gstr2.js
import dayjs from 'dayjs';

/**
 * Transform purchase bills into GST offline‑utility JSON for GSTR‑2 upload.
 * @param {Array} bills            – array of purchase bill objects
 * @param {string} gstin           – your GSTIN
 * @param {string} periodMMYYYY    – MMYYYY string, e.g. "072025"
 * @param {string} stateCode       – place‑of‑supply state code (defaults to "29")
 */
export function toGSTR2JSON(bills, gstin, periodMMYYYY, stateCode = '29') {
  const b2b = bills.map(bill => ({
    ctin: bill.SupplierGSTIN || bill.SupplierGSTIN || '',
    inv: [
      {
        inum: bill.BillNo,
        idt:  dayjs(bill.BillDate).format('DD-MM-YYYY'),
        val:  Number(bill.TotalAmount || 0),
        pos:  stateCode,
        rchrg: 'N',
        inv_typ: 'R',
        itms: (bill.items || []).map((item, idx) => ({
          num: idx + 1,
          itm_det: {
            ty:        'G',
            hsn_sc:    item.HSN || '',
            qty:       Number(item.Quantity || 0),
            unit:      item.Unit || 'NOS',
            unit_price: Number(item.Rate || 0),
            txval:     Number(item.Amount || 0),
            rt:        Number(item.GSTPercent || 0),
            iamt:      Number(item.IGST || 0),
            camt:      Number(item.CGST || 0),
            samt:      Number(item.SGST || 0),
            csamt:     0.00
          }
        }))
      }
    ]
  }));

  return {
    gstin,
    fp:      periodMMYYYY,
    version: '1.1',
    b2b
  };
}
